import React from "react";

import PageContainer from "../../components/PageContainer";
import { Footer } from "../../components/Footer/Footer";
import { MainHeader } from "../../components/MainHeader";
import { Heading } from "@r360/library";
import errorImg from "../../assets/error.png";
import useTranslate from "../../hooks/useTranslate";

const ModuleInactive = () => {
    const t = useTranslate();
    return (
        <>
            <MainHeader />
            <PageContainer>
                <div className="u-d-flex u-flex-center u-flex-column">
                    <img src={errorImg} alt="error" className="u-mb-24" />
                    <Heading type="h3" styleAs="h3">
                        {t("book.module_disabled")}
                    </Heading>
                </div>
            </PageContainer>
            <Footer />
        </>
    );
};

export default ModuleInactive;
